import { Textarea } from "@/components/ui/textarea";
import { AnswerEvaluation } from "@/schema/console/evaluation-reports/AnswerEvaluation";
import EvaluationRadioGroup from "@/src/console/(auth)/_components/EvaluationReport/AnswerContent/EvaluationRadioGroup";

interface AssessorCheckItemProps {
  index: number;
  answerEvaluation: AnswerEvaluation;
}

function AssessorCheckItem({
  index,
  answerEvaluation: { comment, content, evaluation_rate },
}: AssessorCheckItemProps) {
  return (
    <div className=" flex flex-col space-y-4">
      <p className=" text-sm font-normal text-cool-gray-700">
        {index + 1}、 {content}
      </p>
      <EvaluationRadioGroup evaluationRate={evaluation_rate} />
      <Textarea
        value={comment ?? ""}
        className="grow"
        placeholder="Assessor memo"
        disabled={true}
      />
    </div>
  );
}

export default AssessorCheckItem;
